import styled from '../../styled';
import { COLORS } from '../../themes/color';

export const MockTabBar = styled('div')`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

export const MockTab = styled('button')<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: ${(p) => (p.$active ? COLORS.PRIMARY : '#64748b')};
  background: ${(p) => (p.$active ? '#eef3ff' : '#fff')};
  border: 1px solid ${(p) => (p.$active ? '#d4e0ff' : '#e2e8f0')};
  border-radius: 8px;
  padding: 7px 12px;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s, color 0.2s;
  white-space: nowrap;

  &:hover {
    border-color: ${COLORS.PRIMARY};
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.PRIMARY};
    outline-offset: 2px;
  }
`;

export const OutputPanel = styled('div')`
  background: #fff;
  border: 1px solid #ececea;
  border-radius: 10px;
  padding: 12px 14px;
  min-width: 0;
`;
